// JavaScript source code
import React from 'react';
import { Link, withRouter } from "react-router-dom";

function Navigation() {
    return (
        <nav className="navbar navbar-dark navbar-expand-lg fixed-top bg-white portfolio-navbar gradient">
            <div className="container">
                <Link className="navbar-brand logo" to="/">Imagineering Today</Link>
                <button data-bs-toggle="collapse" className="navbar-toggler" data-bs-target="#navbarNav">
                    <span className="visually-hidden">Toggle navigation</span>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/cv">About Me</Link></li>
                        <li className="nav-item"><a className="nav-link" target="_blank" href="https://portal.imagineeringtoday.com/login">Login</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default withRouter(Navigation);